import { BodyValueFeatureAuth } from './types';
import { HeadCell } from 'shell/components/shared/table/types';

export const headCells: HeadCell<BodyValueFeatureAuth, keyof BodyValueFeatureAuth>[] = [
  {
    id: 'value',
    label: 'Valore',
  },
  {
    id: 'description',
    label: 'Descrizione',
  },
  {
    id: 'action',
    label: 'Azioni',
  },
];
